import React from "react";
import Navigation from "@components/common/Navigation/Navigation";
import Footer from "@components/common/footer/Footer";
import AlertBox from "@components/common/AlertBox";
import PopUpAlertMessageBox from "@components/common/PopUpAlertMessageBox";
import PopUpBanner from "@components/common/PopUpBanner";
import FloatingActionButton from "@components/common/FloatingActionButton";

import "./NotFoundApp.scss";

export default function NotFoundApp() {
  return (
    <div className="row-height-100">
      <AlertBox />
      <PopUpAlertMessageBox />
      <PopUpBanner />
      <Navigation />
      <main>
        <div className="container main-container wrapper-not-found-message">
          <div className="container-not-found-message">
            <img
              src="/assets/images/img-page-not-found.png"
              alt="Page Not Found"
              className="img-page-not-found"
            />

            <div>
              <p className="highlight">
                對不起！此網頁面並不存在。
                <a href={process.env.REACT_APP_THREE_COM_DOMAIN}>按此</a>
                探索更多。
              </p>
            </div>

            <div>
              <p className="highlight">
                Sorry! Page not found.{" "}
                <a href={process.env.REACT_APP_THREE_COM_DOMAIN + "/en"}>
                  Click here
                </a>{" "}
                to explore more.
              </p>
            </div>

            <div className="container-btn-home">
              <a
                className="btn btn-primary"
                href={process.env.REACT_APP_THREE_COM_DOMAIN}
              >
                主頁 Home page
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer />
      <FloatingActionButton/>
    </div>
  );
}
